import { Box, Container, Typography } from "@mui/material";
import React from "react";

export const SectionHeader = ({ title, subtitle }) => {
  return (
    <Container maxWidth="md">
      <Typography
        variant="h6"
        color="textSecondary"
        textAlign="center"
        sx={{
          fontFamily: "'Cormorant Garamond', serif",
          fontWeight: 400,
          fontSize: { xs: "1rem", md: "1.1rem" },
          letterSpacing: "0.2em",
          textTransform: "uppercase",
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          width: 50,
          height: "1.5px",
          background:
            "linear-gradient(90deg, transparent, var(--clr-primary), transparent)",
          mx: "auto",
          my: 1.5,
        }}
      />
      <Typography
        variant="body1"
        fontWeight="bold"
        color="textPrimary"
        textAlign="center"
        mb={{ xs: 3, md: 6 }}
        sx={{
          fontFamily: "'Lato', sans-serif",
          fontSize: { xs: "1rem", md: "1.15rem" },
        }}
      >
        {subtitle}
      </Typography>
    </Container>
  );
};
